import { Component, OnInit, ViewChild } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { DataBridgeService } from '../../../services/data-bridge.service';
import { NetworkService } from '../../../services/network.service';

@Component({
  selector: 'app-plan-preview',
  templateUrl: './plan-preview.component.html',
  styleUrls: ['./plan-preview.component.scss']
})

export class PlanPreviewComponent implements OnInit {
  @ViewChild('fileInput', { static: false }) fileInput;
  @ViewChild('uploadCard', { static: false }) uploadCard;
  cardMessage = "Plan Parser : ";
  fileUploaded: boolean;
  uploading: boolean;
  layout: Object;
  heading = "Please upload floor plan to view the preview.";
  borderStyle="";
  width: number;
  height: number;
  pointToUnitMapping: number;
  fontSize: number;
  theme: string = 'light';
  seatPosition: BehaviorSubject<any> = new BehaviorSubject(null)

  constructor(private _network: NetworkService, private dataServ: DataBridgeService) { }

  ngOnInit() {
  }

  ngAferViewInit(){
  }

  setFloorDimesion() {
    // Setting up floor width and height
    let points, x = 0, y = 0;
    this.width = 0; this.height = 0;
    if (this.layout[0].floor.floorPlanAvailable) {
      const commaSeparated = this.layout[0].floor.wkt.replace(/ /g, ',');
      const spaceSeparated = commaSeparated.replace(/\),/g, ' ');
      points = spaceSeparated.replace(/\(/g, '');
      points.split(' ').forEach((point, index) => {
        if (parseInt(point.split(',')[0]) > this.width) {
          this.width = parseInt(point.split(',')[0]);
        }
        if (parseInt(point.split(',')[1]) > this.height) {
          this.height = parseInt(point.split(',')[1]);
        }
      });
      if ((this.width - x) > 50) {
        this.pointToUnitMapping = 20;
        this.fontSize = 7;
      }
      else {
        this.pointToUnitMapping = 30;
        this.fontSize = 9;
      }
      this.width = (this.width - x) * this.pointToUnitMapping;
      this.height = (this.height - y) * this.pointToUnitMapping;
    } else {
      this.width = 30;
      this.height = 20;
      this.width = (this.width - x) * this.pointToUnitMapping;
      this.height = (this.height - y) * this.pointToUnitMapping;
    }
  }

  uploadExcel(){
    this.fileInput.nativeElement.click();
  }

  onFileSelected(event) {
    if(event.target.files[0]){
      this.uploading = true;
      this.borderStyle = "solid orange";
      this.heading = "Loading..."
      let selectedFile = event.target.files[0];
      const formData = new FormData();
      formData.append("file", selectedFile, selectedFile.name);
      this.cardMessage = `Parsing file : \n${selectedFile.name}`
      this._network.getPreviewLayout(formData).subscribe((res)=>{
        this.uploading = false;
        this.fileUploaded = true;
        this.borderStyle="solid #91cb23";
        this.layout = this.dataServ.convertDataToGeoJson({floor: res});
        this.cardMessage = `Parsed file : \n${selectedFile.name}`
      }, (err)=>{
        this.cardMessage = `Failed to Parse : \n${selectedFile.name}`
        this.heading = "Some error occured while trying to parse the map."
        this.borderStyle='solid red'
      });
      // this.uploadCard.style.border = "solid #91cb23"
    }
  }

  resetPreview(){
    this.uploading = false;
    this.fileUploaded = false;
    this.cardMessage = "Plan Uploader : ";
    this.heading = "Please upload floor plan to view the preview.";
    this.borderStyle="";
  }

}
